import { render, staticRenderFns } from "./nueva-cita.vue?vue&type=template&id=91569286&lang=pug&"
import script from "./nueva-cita.vue?vue&type=script&lang=js&"
export * from "./nueva-cita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports